/**
 * 电子面单账号类型
 *
 * ⭐️ 重要！ 新增类型，需要map新增电子面单中文映射
 * @see src/map/EwaybillTypeNameMap.ts
 *
 * ⭐️ 重要！ 新增类型，需要前往电子面单设置页面同步新增分组信息
 * @see src/scenes/setting/EwaybillAccount/type.ts
 * @see src/scenes/setting/EwaybillAccount/services.ts
 */
enum EwaybillType {
    /**
     * 在菜鸟官网申请的电子面单（暂未对接）
     */
    CAINIAO = "CAINIAO",

    /**
     * 淘宝后台申请的菜鸟面单，使用需要订购发货易淘宝版
     */
    TAOBAO_CAINIAO = "TAOBAO_CAINIAO",

    /**
     * 淘宝后台申请的菜鸟电子面单，通过授权的方式使用，无需订购，使用appKey:23299489的app授权
     */
    TAOBAO_CAINIAO_AUTH = "TAOBAO_CAINIAO_AUTH",

    /**
     * 淘宝后台申请的菜鸟电子面单，发货易电子面单共享系统共享，调用共享系统的API
     */
    TAOBAO_CAINIAO_AUTH_SHARE = "TAOBAO_CAINIAO_AUTH_SHARE",

    /**
     * 京东无界电子面单（非京东快递，类似菜鸟的第三方快递汇集），需要订购发货易京东版
     */
    JD = "JD",

    /**
     * 京东无界电子面单，通过发货易电子面单共享系统共享，调用共享系统的API
     */
    JD_SHARE = "JD_SHARE",

    /**
     * 京东无界站外电子面单授权
     */
    JD_AUTH = "JD_AUTH",

    /**
     * 京东物流云
     */
    JDL = "JDL",

    /**
     * 快递公司官方电子面单（网点）
     */
    OFFICIAL = "OFFICIAL",

    /**
     * 通过 电子面单共享 系统共享的单号
     */
    OFFICIAL_SHARE = "OFFICIAL_SHARE",

    /**
     * 拼多多店铺申请的电子面单，需要订购发货易
     */
    PDD = "PDD",

    /**
     * 拼多多店铺申请的电子面单，通过，发货易电子面单共享系统共享，调用共享系统的API
     */
    PDD_SHARE = "PDD_SHARE",

    /**
     * 拼多多站外电子面单，无需订购，使用client id：7e261fc0a4c8403ca541e5baf9ef1bf6的app进行授权
     */
    PDD_AUTH = "PDD_AUTH",

    /**
     * 拼多多站外电子面单，通过发货易电子面单共享系统共享，调用共享系统的API
     */
    PDD_AUTH_SHARE = "PDD_AUTH_SHARE",

    /**
     * 抖音电子面单
     */
    JINRITEMAI = "JINRITEMAI",

    /**
     * 抖音站外电子面单
     */
    JINRITEMAI_AUTH = "JINRITEMAI_AUTH",

    /**
     * 抖音站外授权共享面单
     */
    JINRITEMAI_AUTH_SHARE = "JINRITEMAI_AUTH_SHARE",

    /**
     * 抖音电子面单共享
     */
    JINRITEMAI_SHARE = "JINRITEMAI_SHARE",

    /**
     * 抖音电子面单店铺授权
     */
    JINRITEMAI_SHOP_AUTH = "JINRITEMAI_SHOP_AUTH",

    JINRITEMAI_IOP = "JINRITEMAI_IOP",

    /**
     * @deprecated
     * 抖音在线寄件 （虚拟类型 电子面单列表不展示）
     */
    JINRITEMAI_ONLINE_SHIP = "JINRITEMAI_ONLINE_SHIP",

    JINRITEMAI_SUPPLIER = "JINRITEMAI_SUPPLIER",

    KWAISHOP_DROPSHIP = "KWAISHOP_DROPSHIP",

    /**菜鸟裹裹 */
    CAINIAO_GUOGUO = "CAINIAO_GUOGUO",

    /** 快手电子面单 */
    KWAISHOP = "KWAISHOP",

    /** 快手店铺申请的共享电子面单，需要订购发货易。 */
    KWAISHOP_SHARE = "KWAISHOP_SHARE",

    KWAISHOP_SHOP_AUTH = "KWAISHOP_SHOP_AUTH",

    WEBUY = "WEBUY",

    /** 微信小店电子面单 */
    CHANNEL_SHOP = "CHANNEL_SHOP",

    /** 微信小店电子面单共享 */
    CHANNEL_SHOP_SHARE = "CHANNEL_SHOP_SHARE",

    /** 微信小店电子面单授权 */
    CHANNEL_SHOP_AUTH = "CHANNEL_SHOP_AUTH",

    /** 微信小店官方代发电子面单 */
    CHANNEL_SHOP_DROPSHIP = "CHANNEL_SHOP_DROPSHIP",

    XIAOHONGSHU = "XIAOHONGSHU",

    XIAOHONGSHU_AUTH = "XIAOHONGSHU_AUTH",

    /** 小红书共享 */
    XIAOHONGSHU_SHARE = "XIAOHONGSHU_SHARE",

    /** 爱库存电子面单 */
    AIKUCUN = "AIKUCUN",
}

export default EwaybillType;
